import { ArrowRight } from 'lucide-react';
import OnboardingLayout from './OnboardingLayout';
import { getClinicDetails } from '../../Utils/clinicAuth';

/* Tailwind's opacity modifier doesn't work on our var(--cv2-*)-based custom colors (confirmed
 * on the other v2 pages), so these opacity-tinted values go through color-mix() instead. */
const SCOPED_STYLES = `
  .cv2-welcome-copy { color: color-mix(in srgb, var(--cv2-foreground) 45%, transparent); }
  .cv2-welcome-cta { color: color-mix(in srgb, var(--cv2-foreground) 55%, transparent); transition: color 0.15s ease; }
  .cv2-welcome-cta:hover { color: var(--cv2-foreground); }
`;

const Welcome = ({ onNext }) => {
    const clinicDetails = getClinicDetails();
    const doctorName = clinicDetails?.doctor_name;
    const practiceName = clinicDetails?.practise_name;

    return (
        <OnboardingLayout stepKey="welcome" showBack={false}>
            <style>{SCOPED_STYLES}</style>
            <div className="flex-1 flex">
                <div className="ml-auto w-full md:max-w-[500px] flex flex-col justify-center px-7 sm:px-12 md:px-16 py-16">
                    <div className="mb-12">
                        <div className="flex items-center gap-[7px] mb-7">
                            <div className="w-[5px] h-[5px] rounded-full bg-claraview-secondary" />
                            <span className="font-spaceMono text-[10px] tracking-[1px] text-claraview-secondary uppercase">
                                Subscription Active
                            </span>
                        </div>
                        <h1 className="font-normal text-[44px] sm:text-[52px] leading-[50px] sm:leading-[58px] tracking-[-1.4px] text-cv2-foreground mb-[18px] normal-case">
                            Welcome,<br />{doctorName ? `Dr. ${doctorName}.` : 'Doctor.'}
                        </h1>
                        <p className="cv2-welcome-copy text-base leading-[26px] max-w-[360px] normal-case">
                            {practiceName
                                ? `${practiceName} is live on Claraview. Let's get your practice set up in a few quick steps.`
                                : "Your practice is live on Claraview. Let's get it set up in a few quick steps."}
                        </p>
                    </div>
                    <button
                        type="button"
                        onClick={onNext}
                        className="cv2-welcome-cta inline-flex items-center gap-[10px] w-fit font-spaceMono text-[11px] tracking-[1px] uppercase"
                    >
                        Begin setup <ArrowRight className="w-[13px] h-[13px]" strokeWidth={1.5} />
                    </button>
                </div>
            </div>
        </OnboardingLayout>
    );
};

export default Welcome;
